// tied to segment.track method calls
export enum SegmentTrack {
  click = 'Clicked',
  routeChange = 'Route Changed',
  groupCodeSignupBegan = 'Group Code Sign Up Began',
  ssoSignUpBegan = 'SSO Sign Up Began',
  signInBegan = 'Sign In Began',
  signUpBegan = 'Sign Up Began',
  resetPasswordBegan = 'User Reset Password Began',
  // thrive API-related track
  signUp = 'User Signed Up',
  signIn = 'User Signed In',
  resetPassword = 'User Reset Password',
  signOut = 'User Signed Out',
  appleAppStoreIconClicked = 'Apple App Store Icon Clicked',
  googlePlayIconClicked = 'Google Play Icon Clicked',
  thriveDemoRequested = 'Thrive Demo Requested'
}

/**
 * list of links/buttons tracked via segment.track method calls
 */
export enum SegmentElement {
  privacyPolicyLink = 'Privacy Policy',
  termsLink = 'Terms and Conditions',
  forgotPassword = 'Forgot Password',
  signUpLink = 'Sign Up',
  signInLink = 'Sign In',
  appStoreLink = 'App Store',
  googlePlayLink = 'Google Play',
}

/**
 * expected page names for Data Science
 */
export enum SegmentPage {
  signUp = 'Enter Email',
  logIn = 'Enter Email',
  forgotPassword = 'Sign In - Reset Password',
  password = 'Sign In - Enter Password',
  signUpDetails = 'Group Code Sign Up',
  resetPassword = 'Reset Password',
  home = 'Account Creation Confirmation',
  intro = 'Introduction from Arianna', // aka splash page
  app = 'App Download', // sms / qr
  ssoSignIn = 'SSO Sign In',
  ssoSignUp = 'SSO Sign Up',
  course = 'Course',
  courseLoggedOut = 'Course - Logged Out',
  courseOverview = 'Course - Overview',
  courseThisLesson = 'Course - This Lesson',
  coursePlaylist = 'Course - Course Playlist',
  courseAllResources = 'Course - All Resources',
  newHome = 'Home - Logged Out',
  newHomeLoggedIn = 'Home - Logged In',
  signIn = 'Sign In',
  enterPassword = 'Enter Password',
  lessonFullScreen = 'Lesson - Full Screen',
}

/**
 * namespace for Thrive Marketing/Google Analytics tracking via Segment
 * ("App" is specifically requested by the Marketing team)
 */
export enum SegmentGATrack {
  app = 'App',
}
